import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { disconnectSocket, initializeSocket, joinUidRoom, leaveUidRoom } from '../../redux/saga/socket';
import { devicesActions } from '../../redux/slice/devices.slice';

const AppBoot = () => {
    const selectedDevice = useSelector(devicesActions.selectors.getSelectedDevice);
    const previousRoomRef = useRef();

    useEffect(() => {
        initializeSocket();
        return () => {
            disconnectSocket();
        };
    }, []);

    useEffect(() => {
        const newUid = selectedDevice?.uid;
        const prevUid = previousRoomRef.current;

        if (prevUid && prevUid !== newUid) {
            leaveUidRoom({ uid: prevUid });
            previousRoomRef.current = undefined;
        }

        if (newUid && newUid !== prevUid) {
            joinUidRoom({ uid: newUid });
            previousRoomRef.current = newUid;
        }

        return () => {
            if (previousRoomRef.current) {
                leaveUidRoom({ uid: previousRoomRef.current });
                previousRoomRef.current = undefined;
            }
        };
    }, [selectedDevice?.uid]);
    return null
}

export default AppBoot
